import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSentimentBefore = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 235 100",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.5
	},
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "axis",
		children: [
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1.0051,0,0,1.0051,-146.214,-284.005)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M159.92,350.334L363.949,350.334",
					style: {
						fill: "none",
						stroke: "black",
						strokeOpacity: .05,
						strokeWidth: "0.99px"
					}
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "matrix(1,0,0,1,-877.16,-66.597)",
				children: [/* @__PURE__ */ _jsx("g", { transform: "matrix(13,0,0,13,1095.64,150.104)" }), /* @__PURE__ */ _jsxs("text", {
					x: "1059.3px",
					y: "150.104px",
					style: {
						fontFamily: "'Aileron-Regular', 'Aileron'",
						fontSize: 13,
						fill: "rgb(183,183,183)"
					},
					children: [
						"T",
						/* @__PURE__ */ _jsx("tspan", {
							x: "1066.45px ",
							y: "150.104px ",
							children: "o"
						}),
						"day"
					]
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "matrix(1,0,0,1,-989.296,-104.452)",
				children: [/* @__PURE__ */ _jsx("g", { transform: "matrix(13,0,0,13,1074.72,186.377)" }), /* @__PURE__ */ _jsx("text", {
					x: "1003.97px",
					y: "186.377px",
					style: {
						fontFamily: "'Aileron-Regular', 'Aileron'",
						fontSize: 13,
						fill: "rgb(183,183,183)"
					},
					children: "90 days ago"
				})]
			})
		]
	}), /* @__PURE__ */ _jsxs("g", {
		id: "sentiment-BEFORE",
		transform: "matrix(1,0,0,1,-1,8)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "sentiment",
			transform: "matrix(1.84523,-7.52477e-17,2.94484e-17,-0.962601,-278.315,335.699)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M160.898,319.282C160.898,319.282 197.213,314.562 211.651,314.797C225.71,315.026 230.853,319.825 244.839,319.524C258.825,319.223 270.726,318.203 270.726,318.203",
				style: {
					fill: "none",
					stroke: "rgb(255,152,0)",
					strokeWidth: "2.5px"
				}
			})
		}), /* @__PURE__ */ _jsxs("g", {
			transform: "matrix(1,0,0,1,-143.484,-232.218)",
			children: [/* @__PURE__ */ _jsx("g", { transform: "matrix(15,0,0,15,364.705,251.981)" }), /* @__PURE__ */ _jsx("text", {
				x: "333.5px",
				y: "251.981px",
				style: {
					fontFamily: "'Aileron-Black', 'Aileron'",
					fontWeight: 900,
					fontSize: 15,
					fill: "rgb(255,152,0)"
				},
				children: "FAIR"
			})]
		})]
	})]
});
export default SvgSentimentBefore;
